<template>
  <div class="box box-info">
    <div class="p-toolbar p-component mb-4">
      <warehouseGroupDialog ref="openDialog"/>
    </div>
      <warehouseGroupList @edit-warehouseGroup= "editWarehouseGrp" @deleteWarehouseGroup="deletWarehouseGrp"/>
    </div>
</template>
<script>
import warehouseGroupList from './warehouseGroupList.vue'
import warehouseGroupDialog from '../warehouseDialog/warehouseGroupDialog.vue'
export default {
  name: 'warehouseGroup',
  data() {
    return {
    }
  },
  methods: {
    editWarehouseGrp(data) {
      this.$refs.openDialog.editWarehouseGrp(data)
    },
    deletWarehouseGrp(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    warehouseGroupList,
    warehouseGroupDialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">

</style>



// WEBPACK FOOTER //
// WarehouseGroup.vue?3db76c83